import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';

interface ViewMikrotikProps extends RouteComponentProps<{ id: string }> {
    changeToggle(action?: boolean): void
}

@observer export default class ViewMikrotik extends React.Component<ViewMikrotikProps> {

    @observable private router: any = {};
    @observable private redirect = false;
    @observable private isLoaded = false;
    @observable private testingConnection = false;
    @observable private testConnectionResult: any = null;
    @observable private pendientes: any[] = [];
    @observable private totalPendientes = 0;
    @observable private cargandoCorte = false;
    private testConnectionRequestId = 0;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const id = this.props.match.params.id;
        if (!id || id === "undefined") {
            toast.error("Error cargando el router MikroTik");
            this.redirect = true;
            return;
        }
        http.get(`/api/mikrotik_router/read/${id}`).then((response) => {
            const data = response.data;
            let r: any = data && data.response;
            if (Array.isArray(r)) {
                r = r[0];
            }
            if (r == null || typeof r !== "object") {
                r = data && typeof data === "object" && !Array.isArray(data) ? data : null;
            }
            if (r == null) {
                toast.error("Error cargando el router MikroTik");
                this.redirect = true;
                return;
            }
            this.router = { ...r };
            const nameVal = r.name != null && String(r.name) !== "" ? r.name : r.nombre;
            const userVal = r.username != null && String(r.username) !== "" ? r.username : r.usuario;
            this.router.name = nameVal != null ? String(nameVal) : "";
            this.router.username = userVal != null ? String(userVal) : "";
            delete this.router.nombre;
            delete this.router.usuario;
            this.cargarPendientes(id);
            this.isLoaded = true;
        }).catch(() => {
            toast.error("Error cargando el router MikroTik");
            this.redirect = true;
        });
    }

    private cargarPendientes = (routerId: string): void => {
        http.get(`/api/contract/pendiente_desconexion_router/${routerId}`).then((response) => {
            const lista = response.data && Array.isArray(response.data.response) ? response.data.response : [];
            this.pendientes = lista;
            this.totalPendientes = lista.length;
        }).catch(() => {
            this.pendientes = [];
            this.totalPendientes = 0;
            toast.error("Error cargando pendientes");
        });
    }

    private hayPendientesCorte = (): boolean => {
        return this.pendientes.some((contrato: any) =>
            contrato.status === "Pendiente Desconexion" || contrato.status === "Pendiente Retiro"
        );
    }

    private hacerCorte = (): void => {
        if (this.cargandoCorte || !this.hayPendientesCorte()) {
            return;
        }
        swal({
            title: "Confirmar corte",
            text: "Se van a desconectar los contratos en pendiente de desconexión y pendiente de retiro de este router. ¿Seguro que quieres continuar?",
            icon: "warning",
            buttons: ["Cancelar", "Confirmar"],
            dangerMode: true,
        }).then((confirmar) => {
            if (!confirmar) {
                return;
            }
            this.cargandoCorte = true;
            http.post('/api/contract/corte', JSON.stringify({ id: Number(this.router.id) })).then((response) => {
                const data = response.data || {};
                const body = (data.message != null || data.fallidos_message != null || data.sin_router_message != null || data.fallidos_contratos != null)
                    ? data
                    : (data.response && !Array.isArray(data.response) ? data.response : data);
                this.mostrarResultadoCorte(body);
                this.cargarPendientes(String(this.router.id));
            }).catch(() => {
                toast.error("Error al hacer el corte");
            }).finally(() => {
                this.cargandoCorte = false;
            });
        });
    }

    private mostrarResultadoCorte = (body: any): void => {
        const fallidos = Array.isArray(body.fallidos_contratos) ? body.fallidos_contratos : [];
        const partes: string[] = [];
        if (body.message) {
            partes.push(String(body.message));
        }
        if (body.fallidos_message) {
            partes.push(String(body.fallidos_message));
        }
        if (body.sin_router_message) {
            partes.push(String(body.sin_router_message));
        }
        const mensaje = partes.join("\n\n");
        const titulo = "Corte realizado";
        if (fallidos.length === 0) {
            swal({
                title: titulo,
                text: mensaje || "El corte terminó."
            });
            return;
        }
        const contenido = document.createElement("div");
        contenido.style.textAlign = "left";
        const filas = fallidos.map((contrato: any) => {
            const cliente = contrato.client != null ? contrato.client : contrato.cliente;
            const fallo = contrato.message || "Falló";
            return "<tr><td>" + this.escapeHtml(contrato.id) + "</td><td>" +
                this.escapeHtml(cliente) + "</td><td>" + this.escapeHtml(contrato.ip) +
                "</td><td>" + this.escapeHtml(fallo) + "</td></tr>";
        }).join("");
        contenido.innerHTML =
            "<p style=\"white-space:pre-line;margin-top:0\">" + this.escapeHtml(mensaje || "El corte terminó.") + "</p>" +
            "<table style=\"width:100%;margin-top:6px;font-size:12px\">" +
            "<thead><tr><th align=\"left\">ID</th><th align=\"left\">Cliente</th><th align=\"left\">IP</th><th align=\"left\"></th></tr></thead>" +
            "<tbody>" + filas + "</tbody></table>";
        swal({
            title: titulo,
            content: { element: contenido }
        });
    }

    private escapeHtml = (value: any): string => {
        return String(value == null ? "" : value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }

    private testConnection = (): void => {
        const requestId = ++this.testConnectionRequestId;
        this.testingConnection = true;
        this.testConnectionResult = null;
        http.post(`/api/mikrotik_router/test_connection`, JSON.stringify({ id: this.router.id }))
            .then((response) => {
                if (requestId !== this.testConnectionRequestId) {
                    return;
                }
                this.testingConnection = false;
                const payload = this.parseTestConnectionResponse(response.data);

                if (this.isConnectionTestOk(payload)) {
                    this.testConnectionResult =
                        payload.data != null && typeof payload.data === "object"
                            ? payload.data
                            : null;
                    this.router = { ...this.router, status: 1 };
                    toast.success(
                        payload.message || "Conexión exitosa con el router MikroTik"
                    );
                    return;
                }

                this.testConnectionResult = null;
                this.router = { ...this.router, status: 0 };
                toast.error(this.formatTestConnectionMessage(payload));
            }).catch((error) => {
                if (requestId !== this.testConnectionRequestId) {
                    return;
                }
                this.testingConnection = false;
                this.testConnectionResult = null;
                this.router = { ...this.router, status: 0 };
                const msg = error && error.message ? error.message : error;
                toast.error("Error de conexión: " + (msg || "No se pudo probar la conexión"));
            });
    }

    /** Respuesta de test_connection: { ok, message, data?, ... } — no usar unwrapPayload (confunde `data` del router con envoltura API). */
    private parseTestConnectionResponse(raw: any): any {
        if (raw == null) {
            return null;
        }
        if (typeof raw === "object" && "ok" in raw) {
            return raw;
        }
        if (typeof raw === "object" && raw.response != null) {
            const inner = raw.response;
            if (typeof inner === "object" && "ok" in inner) {
                return inner;
            }
        }
        return raw;
    }

    private isConnectionTestOk(payload: any): boolean {
        if (payload == null || typeof payload !== "object") {
            return false;
        }
        const ok = payload.ok;
        return ok === true || ok === 1 || ok === "true" || ok === "1";
    }

    private formatTestConnectionMessage(payload: any): string {
        if (payload == null) {
            return "No se pudo probar la conexión con el router MikroTik.";
        }
        let msg =
            payload.message ||
            payload.error ||
            "Conexión fallida con el router MikroTik.";
        if (typeof msg !== "string") {
            return String(msg);
        }
        const respuestaIdx = msg.indexOf("Respuesta:");
        if (respuestaIdx !== -1) {
            msg = msg.substring(0, respuestaIdx).trim();
        }
        if (payload.httpCode != null && payload.httpCode !== 0) {
            msg = `${msg} (HTTP ${payload.httpCode})`;
        }
        return msg;
    }

    private unwrapPayload = (raw: any): any => {
        let r: any = raw;
        if (r == null) {
            return null;
        }
        if (typeof r === "object" && "ok" in r) {
            return r;
        }
        if (r && typeof r === "object" && r.data != null) {
            r = r.data;
        }
        if (r && typeof r === "object" && r.response != null) {
            r = r.response;
            if (r && typeof r === "object" && r.data != null) {
                r = r.data;
            }
        }
        if (Array.isArray(r)) {
            r = r[0];
        }
        return r;
    }

    private getResultObject = (): any => {
        const r = this.testConnectionResult;
        if (r == null || typeof r !== "object") {
            return null;
        }
        return r;
    }

    private getResultKeys = (): string[] => {
        const r: any = this.getResultObject();
        if (r == null || typeof r !== "object") {
            return [];
        }
        try {
            return Object.keys(r);
        } catch {
            return [];
        }
    }

    private getResultValue = (key: string): string => {
        const r: any = this.getResultObject();
        if (r == null || typeof r !== "object") {
            return "";
        }
        const v = r[key];
        if (v == null) {
            return "";
        }
        return String(v);
    }

    render() {
        if (this.redirect) {
            return <Redirect to="/mikrotik" />
        }
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Router MikroTik: {this.router.name}</h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`/mikrotik`}>
                                            <button className="btn btn-danger btn-sm pull-right" type="button">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-2 col-form-label">Nombre</label>
                                    <div className="col-sm-10">
                                        <p className="form-control-plaintext">{this.router.name}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-2 col-form-label">IP</label>
                                    <div className="col-sm-10">
                                        <p className="form-control-plaintext">{this.router.ip}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-2 col-form-label">Estado de conexión</label>
                                    <div className="col-sm-10">
                                        <p className="form-control-plaintext">
                                            {Number(this.router.status) === 1 ? (
                                                <span className="text-success" style={{ fontWeight: 'bold' }}>Conexión exitosa</span>
                                            ) : (
                                                <span className="text-danger" style={{ fontWeight: 'bold' }}>Conexión fallida</span>
                                            )}
                                        </p>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-2 col-form-label">Usuario</label>
                                    <div className="col-sm-10">
                                        <p className="form-control-plaintext">{this.router.username}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <label className="col-sm-2 col-form-label">Contraseña</label>
                                    <div className="col-sm-10">
                                        <p className="form-control-plaintext">******</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {sessionService.canViewSection("MikroTik.edit") &&
                                            <Link to={`/mikrotik/${this.router.id}`}>
                                                <button type="button" className="btn btn-primary pull-right">Editar</button>
                                            </Link>
                                        }
                                        {sessionService.canViewSection("MikroTik.view") &&
                                            <button onClick={this.testConnection} type="button" className="btn btn-info pull-right" disabled={this.testingConnection}>
                                                {this.testingConnection ? "Probando..." : "Probar Conexión"}
                                            </button>
                                        }
                                    </div>
                                </div>

                                {sessionService.canViewSection("MikroTik.view") && this.testConnectionResult != null &&
                                    <div className="row" style={{ marginTop: 10 }}>
                                        <div className="col-md-12">
                                            <div className="card" style={{ boxShadow: "none", border: "1px solid rgba(0,0,0,.125)" }}>
                                                <div className="card-header">
                                                    <div className="row" style={{ alignItems: "center" }}>
                                                        <div className="col-sm-8">
                                                            <h5 className="card-title" style={{ marginBottom: 0 }}>Resultado de prueba de conexión</h5>
                                                        </div>
                                                        <div className="col-sm-4" />
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <h5 style={{ marginTop: 0, marginBottom: 12, color: "#111", fontWeight: 700 }}>Datos MikroTik</h5>

                                                    {[
                                                        { label: "Arquitectura", key: "architecture-name" },
                                                        { label: "Bloques malos", key: "bad-blocks" },
                                                        { label: "Board", key: "board-name" },
                                                        { label: "Fecha de compilación", key: "build-time" },
                                                        { label: "CPU", key: "cpu" },
                                                        { label: "Núcleos CPU", key: "cpu-count" },
                                                        { label: "Frecuencia CPU", key: "cpu-frequency" },
                                                        { label: "Carga CPU", key: "cpu-load" },
                                                        { label: "Software de fábrica", key: "factory-software" },
                                                        { label: "Disco libre", key: "free-hdd-space" },
                                                        { label: "Memoria libre", key: "free-memory" },
                                                        { label: "Plataforma", key: "platform" },
                                                        { label: "Disco total", key: "total-hdd-space" },
                                                        { label: "Memoria total", key: "total-memory" },
                                                        { label: "Uptime", key: "uptime" },
                                                        { label: "Versión", key: "version" },
                                                        { label: "Sectores escritos (desde reinicio)", key: "write-sect-since-reboot" },
                                                        { label: "Sectores escritos (total)", key: "write-sect-total" }
                                                    ].map((item) => {
                                                        const value = this.getResultValue(item.key);
                                                        return (
                                                            <div key={item.key} style={{ marginBottom: 10, wordBreak: "break-word" }}>
                                                                <span style={{ color: "#111", fontWeight: 700 }}>
                                                                    <strong>{item.label}</strong>:
                                                                </span>{" "}
                                                                <span>{value !== "" ? value : "—"}</span>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-danger">
                                <h4 className="card-title">Pendientes de desconexión y retiro</h4>
                                <p className="card-category">{this.totalPendientes} contratos de este router</p>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        {sessionService.canViewSection("MikroTik.edit") &&
                                            <button type="button" className="btn btn-danger btn-lg pull-right" onClick={this.hacerCorte} disabled={this.cargandoCorte || !this.hayPendientesCorte()}>
                                                <i className="material-icons">power_off</i> Hacer corte
                                                <div className="ripple-container"></div>
                                            </button>
                                        }
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className=" text-primary">
                                            <tr>
                                                <th>ID</th>
                                                <th>Cliente</th>
                                                <th>Status</th>
                                                <th>IP</th>
                                                <th>Sectorial</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.pendientes.length === 0 ? (
                                                <tr>
                                                    <td colSpan={5}>No hay contratos en pendiente de desconexión o retiro ligados a este router.</td>
                                                </tr>
                                            ) : this.pendientes.map((contrato: any) => (
                                                <tr key={contrato.id}>
                                                    <td>
                                                        <Link to={`/contratos/ver/${contrato.id}`} style={{ color: "#111", textDecoration: "none" }}>{contrato.id}</Link>
                                                    </td>
                                                    <td>
                                                        <Link to={`/contratos/ver/${contrato.id}`} style={{ color: "#111", textDecoration: "none" }}>{contrato.client}</Link>
                                                    </td>
                                                    <td>{contrato.status}</td>
                                                    <td>{contrato.ip}</td>
                                                    <td>{contrato.sectorial}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
